import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Loading from 'components/Loading';
import Button from 'componentsv3/Button';

import './style.css';

class DialogFooter extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      isDisabled = false,
      isLoading = false,
      isRedConfirm = false,
      isShowCancel = true,
      isShowConfirm = true,
      isSubmit = true,
      cancelLabel,
      confirmType = 'confirm',
      confirmLabel,
      onClose,
      onConfirm,
      children,
    } = this.props;
    const isDelete = confirmType === 'delete';

    const showConfirmActionButton =
      confirmLabel ||
      (isDelete ? (
        <FormattedMessage id="SH_Delete" defaultMessage="刪除" />
      ) : (
        <FormattedMessage id="SH_Confirm" defaultMessage="確定" />
      ));

    return (
      <div
        className="v3-dialog-footer"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {isShowCancel && (
          <Button
            type="button"
            variant="outlined"
            buttonType="secondary"
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelLabel || (
              <FormattedMessage id="SH_Cancel" defaultMessage="取消" />
            )}
          </Button>
        )}
        {isShowConfirm && (
          <Button
            className={cx({
              'tw-bg-#ff3b30': isRedConfirm,
            })}
            type={isSubmit ? 'submit' : 'button'}
            buttonType={isDelete || isRedConfirm ? 'secondary' : 'primary'}
            disabled={isDisabled || isLoading}
            onClick={onConfirm}
          >
            {isLoading ? <Loading small btn /> : showConfirmActionButton}
          </Button>
        )}
        {children}
      </div>
    );
  }
}

DialogFooter.propTypes = {
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isRedConfirm: PropTypes.bool,
  isShowCancel: PropTypes.bool,
  isShowConfirm: PropTypes.bool,
  isSubmit: PropTypes.bool,
  cancelLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmType: PropTypes.oneOf(['confirm', 'delete']),
  confirmLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  children: PropTypes.node,
};

export default DialogFooter;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/componentsv3/Dialog/components/DialogFooter/index.js
 **/